import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = (props) => {
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch (e) {
      window.scrollTo(0, 0);
    }

    // Initialize WOW.js if available
    if (typeof window !== 'undefined' && window.WOW) {
      try {
        new window.WOW({ live: true }).init();
      } catch (err) {
        // Silently handle
      }
    }

    // High-performance IntersectionObserver for scroll animations
    const timer = setTimeout(() => {
      const selectors = [
        '.scroll-reveal',
        '.section-full',
        '.contact-form-box',
        '.contact-info-card',
        '.product-card',
        '.blog-card',
        '.icon-nx-box',
        '.sx-separator-outer',
        '.about-max',
        '.banner-outer',
        '.gmap-outline',
        '.reveal-left',
        '.reveal-right',
        '.reveal-zoom'
      ];

      const elements = document.querySelectorAll(selectors.join(', '));

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('revealed');
                entry.target.classList.add('animated');
              }
            });
          },
          { threshold: 0.05, rootMargin: '0px 0px -20px 0px' }
        );

        elements.forEach((el) => {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight) {
            el.classList.add('revealed');
            el.classList.add('animated');
          } else {
            observer.observe(el);
          }
        });
      } else {
        elements.forEach((el) => {
          el.classList.add('revealed');
          el.classList.add('animated');
        });
      }
    }, 120);

    return () => clearTimeout(timer);
  }, [pathname]);

  return <>{props.children}</>;
};

export default ScrollToTop;